<ng-container *ngIf="deal$ | async as deal">
    <dl class="deal-bijtelling__dl">
        <dt i18n="@@deal.summary.label-fiscal-value">Fiscal value</dt>
        <dd>
            {{ deal.pricing.fiscalValue | currency: 'EUR':'symbol-narrow':'1.0-0' }},-
            <ng-container i18n="@@configurator.general.in-vat-abbr">incl. VAT</ng-container>
        </dd>

        <dt i18n="@@configurator.general.vaa-atn">VAA/ATN</dt>
        <dd>
            {{ VAA_ATN | currency: 'EUR':'symbol-narrow':'1.0-0' }},-
            <span class="time-unit" i18n="@@configurator.general.per-month-abbr">p/m</span><br />
        </dd>

        <dt i18n="@@configurator.general.co2">CO2 fee</dt>
        <dd>
            {{ co2 | currency: 'EUR':'symbol-narrow':'1.0-0' }},-
            <span class="time-unit" i18n="@@configurator.general.per-month-abbr">p/m</span><br />
        </dd>
    </dl>
</ng-container>
